document.addEventListener("DOMContentLoaded", () => {

    const header = document.querySelector(".hgp-header");

    if (!header) return;


    /* =====================================================
       DESKTOP MEGA MENU
    ===================================================== */

    const wrapper = header.querySelector(".hgp-mega-wrapper");

    const panels = header.querySelectorAll(".mega-menu-panel");

    const desktopNavItems = header.querySelectorAll(".hgp-nav-item");


    desktopNavItems.forEach((item) => {

        item.addEventListener("mouseenter", () => {

            /*
             * Desktop mega menu must only work
             * at 1280px and above.
             */

            if (window.innerWidth < 1280) return;


            if (wrapper) {

                wrapper.classList.add("active");

            }


            panels.forEach((panel) => {

                panel.classList.remove("active");

            });


            const current = header.querySelector(

                `.mega-menu-panel[data-menu="${item.dataset.menu}"]`

            );


            if (current) {

                current.classList.add("active");

            }

        });

    });


    header.addEventListener("mouseleave", () => {

        if (window.innerWidth < 1280) return;


        if (wrapper) {

            wrapper.classList.remove("active");

        }


        panels.forEach((panel) => {

            panel.classList.remove("active");

        });

    });



    /* =====================================================
       MOBILE / TABLET DRAWER
    ===================================================== */

    const menuToggle = header.querySelector(".hgp-menu-toggle");

    const drawer = header.querySelector(".hgp-mobile-drawer");

    const drawerClose = header.querySelector(
        ".hgp-mobile-drawer-close"
    );

    const drawerBackdrop = header.querySelector(
        ".hgp-mobile-drawer-backdrop"
    );


    function openDrawer() {

        if (!drawer || !menuToggle) return;


        drawer.classList.add("is-open");

        drawer.setAttribute(
            "aria-hidden",
            "false"
        );


        menuToggle.setAttribute(
            "aria-expanded",
            "true"
        );


        document.body.classList.add(
            "hgp-menu-open"
        );

    }


    function closeDrawer() {

        if (!drawer || !menuToggle) return;


        drawer.classList.remove("is-open");

        drawer.setAttribute(
            "aria-hidden",
            "true"
        );


        menuToggle.setAttribute(
            "aria-expanded",
            "false"
        );


        document.body.classList.remove(
            "hgp-menu-open"
        );

    }


    if (menuToggle) {

        menuToggle.addEventListener(
            "click",
            openDrawer
        );

    }


    if (drawerClose) {

        drawerClose.addEventListener(
            "click",
            closeDrawer
        );

    }


    if (drawerBackdrop) {

        drawerBackdrop.addEventListener(
            "click",
            closeDrawer
        );

    }



    /* =====================================================
       TOP LEVEL ACCORDION
    ===================================================== */

    const navTriggers = header.querySelectorAll(
        ".hgp-mobile-nav-trigger"
    );


    navTriggers.forEach((trigger) => {

        trigger.addEventListener("click", () => {

            const isOpen =
                trigger.classList.contains("is-open");


            /*
             * Close other top-level menus.
             */

            navTriggers.forEach((otherTrigger) => {

                if (otherTrigger === trigger) return;


                otherTrigger.classList.remove(
                    "is-open"
                );


                otherTrigger.setAttribute(
                    "aria-expanded",
                    "false"
                );

            });


            /*
             * Toggle current menu.
             */

            trigger.classList.toggle(
                "is-open",
                !isOpen
            );

            const submenu = trigger.nextElementSibling;

            if (!submenu) return;

            if (isOpen) {

                submenu.style.height =
                    submenu.scrollHeight + "px";

                requestAnimationFrame(() => {

                    submenu.style.height = "0px";

                    submenu.style.opacity = "0";

                });

            }
            else {

                submenu.style.height = "0px";

                submenu.style.opacity = "1";

                requestAnimationFrame(() => {

                    submenu.style.height =
                        submenu.scrollHeight + "px";

                });

            }


            submenu.addEventListener("transitionend", () => {

                if (trigger.classList.contains("is-open")) {

                    submenu.style.height = "auto";

                }

            }, { once: true });


            trigger.setAttribute(
                "aria-expanded",
                String(!isOpen)
            );

        });

    });



    /* =====================================================
       SECOND LEVEL ACCORDION
    ===================================================== */

const groupTriggers = header.querySelectorAll(".hgp-mobile-group-toggle");

groupTriggers.forEach((trigger) => {

    trigger.addEventListener("click", () => {

        const links = trigger.parentElement.nextElementSibling;

        if (!links) return;

        const isOpen = trigger.classList.contains("is-open");

        trigger.classList.toggle("is-open");

        if (isOpen) {

            links.style.height = links.scrollHeight + "px";

            requestAnimationFrame(() => {
                links.style.height = "0px";
            });

        } else {

            links.style.height = links.scrollHeight + "px";

            requestAnimationFrame(() => {
                links.style.height = links.scrollHeight + "px";
            });

        }

    });

});



    /* =====================================================
       ESCAPE KEY CLOSE
    ===================================================== */

    document.addEventListener(
        "keydown",
        (event) => {

            if (event.key === "Escape") {

                closeDrawer();

            }

        }
    );



    /* =====================================================
       RESET WHEN RETURNING TO DESKTOP
    ===================================================== */

    window.addEventListener("resize", () => {

        if (window.innerWidth >= 1280) {

            closeDrawer();

        }

    });

});